import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const getStackAmountColor = (playerIsAllIn: boolean) => {
  return playerIsAllIn ? 'text-ph-orange' : 'text-white';
};

const CurrencyDisplay = ({
  stack,
  getCurrencyColor,
  formatCurrency,
  CurrencyIcon,
  isCappedGame,
  playerIsAllIn,
  joining,
  shouldDisplayInBB,
  bigBlind,
}: any) => {
  const isDisplayingBB = shouldDisplayInBB && bigBlind;
  const displayValue = isDisplayingBB ? `${formatCurrency(stack / bigBlind)} BB` : formatCurrency(stack);

  if (joining) {
    return (
      <span className="h-auto">
        <LoadingSpinner size="3" fullWidth={false} className="mx-auto" />
      </span>
    );
  }

  return (
    <span className={twMerge('text-base font-semibold', getStackAmountColor(playerIsAllIn))}>
      <p className="flex items-center gap-1 font-manrope text-base">
        {isCappedGame ? (
          <>
            ({!isDisplayingBB && <CurrencyIcon fill={getCurrencyColor()} />}
            {displayValue})
          </>
        ) : (
          <>
            {!isDisplayingBB && <CurrencyIcon fill={getCurrencyColor()} />}
            {displayValue}
          </>
        )}
      </p>
    </span>
  );
};

export default CurrencyDisplay;
